import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import Form from "./details components/Form";
import { useAxios, useComponent } from "../../hooks";
import {
  actionObject,
  objectFromResponseData,
} from "./details components/actionObject";
import { useSelector } from "react-redux";
import { Loader, PageHeader } from "../../components";
import pages from "../../constants/pages";

export default function ActionDetails({ pageID }) {
  const axios = useAxios();
  const { actionID } = useParams();
  const { loader, pagePermissions } = useComponent({ pageID });

  const [fields, setFields] = useState([]);
  const [editState, setEditState] = useState(true);
  const [actionType, setActionType] = useState([]);
  const [formData, setFormData] = useState(actionObject);

  const { activeBot } = useSelector((state) => state.memberDetails);

  useEffect(() => {
    loader.start(3);
    if (!!actionID) {
      setEditState(false);
    }

    axios({
      url: "/workflow/action-type/" + activeBot.ID,
    }).then((response) => {
      if (response.status) {
        setActionType(response.data);
      }
    });

    axios({
      url:
        "/custom_fields/get_fields_for_agent?agent_id=" +
        activeBot.ID +
        "&is_active=1",
      method: "GET",
    }).then(async (response) => {
      if (response.status) {
        let filterColumns = [
          {
            name: "name",
            label: "Name",
            dataType: "string",
          },
          {
            name: "email",
            label: "Email",
            dataType: "string",
          },
          {
            name: "phone",
            label: "Phone",
            dataType: "string",
          },
          {
            name: "created_by",
            label: "Created By",
            dataType: "string",
          },
        ];
        for await (let field of response.data) {
          filterColumns.push({
            name: field.name,
            label: field.label,
            dataType:
              field.control_id === "61e13a0bf2c60729b06385f3"
                ? field.value_type
                : field.data_type,
            ...(field.control_id === "61dd2dfa1fb38be82e077ed8" && {
              options: field.options,
            }),
          });
        }
        setFields(filterColumns);
        loader.apiComplete();
      }
    });

    if (actionID) {
      axios({
        url: "/workflow/action/" + activeBot.ID + "?action_id=" + actionID,
        disableError: true,
      }).then((response) => {
        if (response.status) {
          setFormData(objectFromResponseData(response.data[0]));
        }

        loader.apiComplete();
      });
    } else {
      loader.apiComplete();
    }
    loader.apiComplete();
  }, [axios, activeBot.ID, loader, actionID]);

  return (
    <Loader>
      <PageHeader
        pageName="Action Details"
        breadcrumbs={[{ location: pages.actionList.route, name: "Actions" }]}
        editIcon={[editState, setEditState, pagePermissions.update]}
      />

      <Form
        fields={fields}
        setFormData={setFormData}
        actionType={actionType}
        formData={formData}
        editState={editState}
        setEditState={setEditState}
      />
    </Loader>
  );
}
